import React from 'react';
import styled from '@emotion/styled';
import {
  ICON_RESIZE32x32_DATA_URL,
  ICON_ADD_FILE22x22_DATA_URL,
  ICON_DOWN16x16_DATA_URL,
  ICON_UP16x16_DATA_URL,
  ICON_RIGHT16x16_DATA_URL
} from '../bins';

export type BinIconType =
  | "resize"
  | "add_file"
  | "up"
  | "down"
  | "right"

export interface BinIconProps extends BinIconState {
  type: BinIconType;
  size?: number;
  onClick?: () => void;
}

export interface BinIconState {

}
export function useBinIcon(): BinIconState {
  return {} as BinIconState;
}

export function BinIcon(props: BinIconProps) {
  const {
    type,
    onClick,
  } = props;
  const size = props.size ?? 32;
  const {
    Container
  } = S;
  return (
    <Container
      type={type}
      style={{
        width: size,
        height: size,
      }}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
    </Container>
  );
}
const S = {
  Container: styled.div<{ type: BinIconType }>`
    display: inline-block;
    vertical-align: middle;
    background-image: ${props => {
      switch (props.type) {
        case "resize": return `url(${ICON_RESIZE32x32_DATA_URL})`;
        case "add_file": return `url(${ICON_ADD_FILE22x22_DATA_URL})`;
        case "up": return `url(${ICON_UP16x16_DATA_URL})`;
        case "down": return `url(${ICON_DOWN16x16_DATA_URL})`;
        case "right": return `url(${ICON_RIGHT16x16_DATA_URL})`;
      }
    }};
    background-size: 100%;
  `,
}
